import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import MyApiClient from '../../../api-client/MyApiClient';

/*
 * "Dati allievo" nel box a destra di dettaglio ordine e dettaglio documento (22/10/2026, prima "Dati
 * intestatario"): chi pratica, cioè per chi è stato acquistato il prodotto. Chi paga sta sotto, nei
 * "Dati fatturazione" (il destinatario del documento).
 *
 * Acquisto per sé: i dati dell'account, letti dal profilo privato come fa la scheda del player.
 * Acquisto per un junior: i dati del junior (nome, nascita, codice fiscale, indirizzo) e sotto il genitore
 * o tutore, con il link alla sua scheda e i suoi contatti, perché il junior non ha email né telefono.
 * Solo testo, niente icone.
 */

const leggiToken = () => {
	try {
		return JSON.parse(sessionStorage.getItem('userDetails') || '{}').idToken || null;
	} catch (e) {
		return null;
	}
};

const dataItaliana = (iso) => {
	if (!iso) return '';
	const [a, m, g] = String(iso).slice(0, 10).split('-');
	return g && m && a ? `${g}/${m}/${a}` : iso;
};

const nomeJunior = (junior) => `${junior?.givenName || ''} ${junior?.familyName || ''}`.trim() || junior?.name || '';

/**
 * Il junior dell'acquisto, fra i junior del genitore: per id, o per nome se l'id non c'è (ordini vecchi).
 * `null` finché non arriva o se l'acquisto non è per un junior.
 */
export const useJunior = (playerId, juniorId, juniorName) => {
	const [junior, setJunior] = useState(null);

	useEffect(() => {
		let annullato = false;
		setJunior(null);
		const token = leggiToken();
		if (!playerId || !token || (!juniorId && !juniorName)) return undefined;
		new MyApiClient()
			.getJuniorsByParent(token, playerId)
			.then((res) => {
				if (annullato || !Array.isArray(res)) return;
				const trovato = res.find((j) => juniorId && (j.userId === juniorId || j.id === juniorId))
					|| res.find((j) => juniorName && nomeJunior(j).toLowerCase() === String(juniorName).trim().toLowerCase());
				setJunior(trovato || null);
			})
			.catch(() => {});
		return () => {
			annullato = true;
		};
	}, [playerId, juniorId, juniorName]);

	return junior;
};

/** Il nome di chi pratica, per la riga «per …» sotto l'articolo. */
export const nomeAllievo = (junior, juniorName) => (junior ? nomeJunior(junior) : '') || juniorName || '';

const Elenco = ({ righe }) => (
	righe.length > 0 ? (
		<dl className="sid-recipient__list">
			{righe.map(([etichetta, valore]) => (
				<React.Fragment key={etichetta}>
					<dt>{etichetta}</dt>
					<dd>{valore}</dd>
				</React.Fragment>
			))}
		</dl>
	) : null
);

const indirizzo = (address) => [
	['Indirizzo', address?.streetAddress],
	['CAP', address?.postalCode],
	['Città', address?.locality],
	['Provincia', address?.province],
	['Nazione', address?.country],
];

export const DatiAllievo = ({ playerId, playerName, juniorId, juniorName, junior: juniorGiaLetto }) => {
	const [dati, setDati] = useState(null);
	const perJunior = !!(juniorId || juniorName);
	const juniorLetto = useJunior(juniorGiaLetto === undefined ? playerId : null, juniorId, juniorName);
	const junior = juniorGiaLetto === undefined ? juniorLetto : juniorGiaLetto;

	useEffect(() => {
		let annullato = false;
		setDati(null);
		const token = leggiToken();
		if (!playerId || !token) return undefined;
		new MyApiClient()
			.getPrivateProfile(token, playerId)
			.then((res) => {
				if (!annullato && res && !res.error) setDati(res.idsPlay || res.idsGuru || null);
			})
			.catch(() => {});
		return () => {
			annullato = true;
		};
	}, [playerId]);

	const linkGenitore = playerId
		? <Link to={`/struttura/clienti/player_profile/${playerId}`}>{playerName || '-'}</Link>
		: playerName;

	if (perJunior) {
		const righeJunior = [
			['Nome', nomeAllievo(junior, juniorName)],
			['Nato il', dataItaliana(junior?.birthdate)],
			['Nato a', junior?.birthPlace],
			['Cod. fiscale', junior?.taxCode],
			...indirizzo(junior?.address),
		].filter(([, valore]) => valore);
		const righeGenitore = [
			['Nome', linkGenitore],
			['Email', dati?.email],
			['Telefono', dati?.phoneNumber],
		].filter(([, valore]) => valore);

		return (
			<>
				<h5 className="sid-order-card__title">Dati allievo</h5>
				<Elenco righe={righeJunior} />
				<h5 className="sid-order-card__title sid-order-card__title--section">Genitore o tutore</h5>
				<Elenco righe={righeGenitore} />
			</>
		);
	}

	const righe = [
		['Nome', linkGenitore],
		['Email', dati?.email],
		['Telefono', dati?.phoneNumber],
		['Cod. fiscale', dati?.taxCode],
		...indirizzo(dati?.address),
	].filter(([, valore]) => valore);

	return (
		<>
			<h5 className="sid-order-card__title">Dati allievo</h5>
			<Elenco righe={righe} />
		</>
	);
};

export default DatiAllievo;
